
import Vue, { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import waiting from '@/components/loading/waiting';

@Component({
  directives: {
    waiting,
  },
})
export default class Dialog extends Vue {
  @Prop({ type: Boolean, required: true }) readonly hasSlot!: boolean;
  @Prop({ type: String, required: false, default: '' }) readonly title!: string;
  @Prop({ type: [String, Object], required: true }) readonly content!: string | VNode;
  @Prop({ type: Array, default: () => ([]) }) readonly buttons!: any[];
  @Prop({ type: Boolean, required: false, default: false }) readonly loading!: boolean;
  @Prop({ type: String, required: false, default: '' }) readonly className!: string;
  @Prop({ type: String, default: 'white' }) readonly componentBackground!: 'white' | 'transparent' | 'grey' |'blurry';

  hasMounted = false;

  mounted () {
    this.hasMounted = true;
  }
}
